import NodeContentApiSerializer from 'rise-ui/serializers/apis/rise-api/content/node.js';

import { keyForAttribute } from 'rise-ui/utils/serializer/map.js';

@keyForAttribute({
  category: 'field_category',
})
export default class FileGalleryFileSerializer extends NodeContentApiSerializer {
  extractAttributes(modelClass, resourceHash) {
    const attrs = super.extractAttributes(...arguments);
    attrs.url = resourceHash.attributes?.uri?.url;
    return attrs;
  }
}
